import { render, staticRenderFns } from "./scb2.vue?vue&type=template&id=b060be7a&scoped=true"
import script from "./scb2.vue?vue&type=script&lang=js"
export * from "./scb2.vue?vue&type=script&lang=js"
import style0 from "./scb2.vue?vue&type=style&index=0&id=b060be7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b060be7a",
  null
  
)

export default component.exports